import { useDisclosure } from "@mantine/hooks"
import { IconTrash } from "@tabler/icons-react"
import { ActionIcon, AreYouSureModal, Loader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { useDeleteContactMutation } from "~/pages/Brand/Suppliers/SuppliersRepository/hooks/useDeleteContactMutation"

type DeleteContactProps = {
  id: string
}

const DeleteContact = ({ id }: DeleteContactProps) => {
  const { t } = useTranslation("organizationSettings")

  const { mutate: deleteSupplierMapping, isPending: isLoading } =
    useDeleteContactMutation({ searchSupplier: "" })

  const [isDeleteModalOpen, deleteModalActions] = useDisclosure(false)

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <ActionIcon icon={<IconTrash />} onClick={deleteModalActions.open} />
      <AreYouSureModal
        opened={isDeleteModalOpen}
        onClose={deleteModalActions.close}
        confirmText={t("supplierSettings.deleteSupplier.confirm")}
        cancelText={t("supplierSettings.deleteSupplier.cancel")}
        onConfirm={() =>
          deleteSupplierMapping(
            { id },
            {
              onSettled: deleteModalActions.close,
            }
          )
        }
        areYouSureText={t("supplierSettings.deleteSupplier.message")}
        title={t("supplierSettings.deleteSupplier.title")}
      />
    </>
  )
}

export default DeleteContact
